import { chakra, VStack } from '@chakra-ui/react'

export const ResultWrapper = chakra(VStack, {
  baseStyle: () => ({
    marginTop: '-24px',
    div: {
      minWidth: '100% !important',
      marginTop: '-16px'
    }
  })
})
